import breadcrumbs from "./breadcrumbs";
import link from "./breadcrumbsLink";
import item from "./breadcrumbsItem";

export type { BreadcrumbsProps } from "./breadcrumbs";
export type { BreadcrumbsLinkProps } from "./breadcrumbsLink";
export type { BreadcrumbsItemProps } from "./breadcrumbsItem";

const Breadcrumbs = Object.assign(breadcrumbs, {
  Link: link,
  Item: item,
});

export default Breadcrumbs;
